import { CognitoHelper } from '../Utilities/CognitoHelper';

// const url = 'https://1sggsyjjfj.execute-api.us-east-1.amazonaws.com';
const url = process.env.REACT_APP_API_URL;

const debugging=true

function stringIsNullOrEmpty(stringToTest){
  if (typeof stringToTest === "string" && stringToTest.length === 0) {
    return true;
  } else if (stringToTest === null) {
    return true;
  }
  return false;
}

function inputDataIsValid(inputData){
  let returnValue = true;

  console.log("inputData: ", JSON.stringify(inputData))

  if (!inputData) returnValue = false;

  if (!inputData.providerEmail
    || stringIsNullOrEmpty(inputData.providerEmail) ){
      console.log("inputDataIsValid: No, due to providerEmail")
      returnValue = false;
  }

  if (!inputData.ptFirstName
    || stringIsNullOrEmpty(inputData.ptFirstName) ){
      console.log("inputDataIsValid: No, due to ptFirstName")
      returnValue = false;
  }
  if (!inputData.ptLastName
    || stringIsNullOrEmpty(inputData.ptLastName) ){
      console.log("inputDataIsValid: No, due to ptLastName")
      returnValue = false;
  }
  if (!inputData.ptDateOfBirth
    || stringIsNullOrEmpty(inputData.ptDateOfBirth) ){
      console.log("inputDataIsValid: No, due to ptDateOfBirth")
      returnValue = false
  }
  if (!inputData.ptSex
    || stringIsNullOrEmpty(inputData.ptSex) ){
      console.log("inputDataIsValid: No, due to ptSex")
      returnValue = false
  }

  if (returnValue) console.log("inputDataIsValid: Yes")

  return returnValue;
}
// At assessment start, gets assessment id for aws
export async function create_assessment(assessmentInput = null) {
  return new Promise(function(resolve) {
    const cognitoHelper = new CognitoHelper()

    const user = cognitoHelper.getUser()

    cognitoHelper.getSession(function(session) {
      console.log('create_assessment.getSession')
      console.log(session)


      let email = user.email;

      if (debugging) {
        console.log(email);
      }

      let body = "";

      if (inputDataIsValid(assessmentInput)){
        body = assessmentInput
        body.useragent = ""
      }
      else{
        body = {
          'useragent' : ""
        }
      }

      let bodyAsString = JSON.stringify(body);

      console.log("bodyAsString: ", bodyAsString);

      fetch(url + '/assessment', {
        method: 'post',
        body: bodyAsString,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + session.accessToken.jwtToken
        }
      }).then(function(resp) {
        if (debugging) console.log('resp.ok: ', resp.ok);

        if (debugging) console.log('resp.status: ', resp.status);

        resp.json().then(function(data) {
          console.log('~~~~~~  data: ', data);

          let assessmentId = data.assessmentId;

          sessionStorage.setItem('assessmentId', assessmentId)

          console.log('~~~~~~  assessmentId: ', assessmentId);

          resolve(assessmentId)
        })
      })
    }, function(error) {
      console.log(`get_primary_care_providers: ${error}`)

      resolve(null)
    })
  })
}

export async function get_primary_care_providers() {
  return new Promise(function(resolve) {
    const cognitoHelper = new CognitoHelper()

    cognitoHelper.getSession(function(session) {
      fetch(url + '/providers', {
        method: 'get',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + session.accessToken.jwtToken
        }
      }).then(function(resp) {
        if (debugging) console.log('resp.ok: ', resp.ok);

        if (debugging) console.log('resp.status: ', resp.status);

        resp.json().then(function(providerData) {
          console.log("providerData: ", providerData);
          console.log('END get_primary_care_providers');

          resolve(providerData)
        })
      })
    }, function(error) {
      console.log(`get_primary_care_providers: ${error}`)

      resolve(null)
    })
  })
}


//uploads data obtained for the assessment
export async function upload_assessment_data(assessment_id, prompt_key, patient_response) {
  //const assessment_id = await sessionStorage.getItem('assessmentId')
  const promptUrl = url + '/' + assessment_id + '/' + prompt_key + '/';
  if (debugging) console.log('url: ', url);
  if (debugging) console.log('assessment_id', assessment_id);
  if (debugging) console.log('prompt url:', promptUrl);

  // console.log('BEGIN get_primary_care_providers');

  const cognitoHelper = new CognitoHelper()

  cognitoHelper.getSession(function(session) {
      let resp = fetch(promptUrl + patient_response, {
        method: 'put',
        body: patient_response,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + session.accessToken.jwtToken
        }
      })

      if (debugging) console.log('resp.ok: ', resp.ok);
      if (debugging) console.log('resp.status: ', resp.status);

  })
}

//When a user submits their response to a questionnaire prompt
export async function record_prompt_response(prompt_key, response) {
  return new Promise(function(resolve) {
    const cognitoHelper = new CognitoHelper()

    const user = cognitoHelper.getUser()

    cognitoHelper.getSession(function(session) {
      console.log(`recording prompt response: ${prompt_key}...`)
      console.log(`recording prompt response: ${prompt_key}, value: ${response}`)

      const assessment_id = sessionStorage.getItem('assessmentId')
        const promptUrl = url + '/' + assessment_id + '/prompt/';

        let body = {
          'response': response,
          'clientElapsedMilliseconds' : getElapsedTime(),
        }

          fetch(promptUrl + prompt_key, {
            method: 'post',
            body: JSON.stringify(body),
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + session.accessToken.jwtToken,
            }
          }).then(function(resp) {
            if (debugging) console.log('resp.ok: ', resp.ok);
            if (debugging) console.log('resp.status: ', resp.status);

            resolve()
          });
    }, function(error) {
      console.log(`record_prompt_response: ${error}`)
      resolve()
    })
  })
}

//Uploads a data obtained from the users voice recording
export async function upload_attachment(prompt_key, attachment, attachmentName, contentType) {
  console.info("uploading attachment, prompt_key: ", prompt_key, ", attachmentName: ", attachmentName)

  return new Promise(function(resolve) {
    const cognitoHelper = new CognitoHelper()

    cognitoHelper.getSession(function(session) {
      const assessment_id = sessionStorage.getItem('assessmentId')
      const promptUrl = url + '/' + assessment_id + '/prompt/';

      console.info("resolved promptUrl:", promptUrl)

      let body = {
        'clientElapsedMilliseconds' : getElapsedTime(),
        'fileName': attachmentName,
        'contentType': contentType //TODO: replace with attachment.type
      }

      fetch(promptUrl + prompt_key + '/attachment', {
        method: 'post',
        body: JSON.stringify(body),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + session.accessToken.jwtToken,
        }
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        // console.info("using this presigned url: ", data.uploadURL)
        //Uploads to URL
        return fetch(data.uploadURL, {
          method: 'PUT',
          body:  attachment,
        }).then(function(response) {
          //Reports a sucessful upload
          if (response.status === 200) {
            fetch(promptUrl + prompt_key + '/attachment', {
              method: 'put',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'blobData',
                'Authorization': 'Bearer ' + session.accessToken.jwtToken,
              }
            })
          }

          resolve(Response.json({}, { status: 200, statusText: "upload succeeded" }));
        })
      });
    })
  })
}

// Gets the elapsed time from assessment start to current
export function getElapsedTime() {
  const startTime = sessionStorage.getItem('startTime')
  //var otherTime = sessionStorage.getItem('sTime')
 // console.log("the START TIME for calculation: ", otherTime);
 // let timepassed = new Date().getTime() - otherTime;
  //console.log("time for section: " , timepassed);
  return new Date().getTime() - startTime;
}